import schoolsApi from 'api-client/schoolStatus';
import { date } from '@/utils/date';

const schoolsModule = {
  state: {
    schools: []
  },
  getters: {
    schools: state => state.schools
  },
  mutations: {
    setSchools(state, schools) {
      state.schools = schools;
    }
  },
  actions: {
    async fetchSchools({commit}) {
      commit('setSchools', []);
      return await schoolsApi.fetchSchools()
        .then((response) => {
          const schoolsFormatted = response.map(s => {
            return {
              ...s,
              status: s.nonOperational ? 'non-operational' : 'operational',
              lastUpdatedFormatted: date(s.lastUpdated),
              operationalDateFormatted: date(s.operationalDate)
            }
          });

          commit('setSchools', schoolsFormatted);
        })
        .catch((err) => {
          if (err.response && err.response.data && err.response.data.message) {
            throw err.response.data.message;
          }

          throw err;
        });
    },
    updateSchoolStatuses({commit}, {schoolCodes, date, nonOperational}) {
      commit('setIsLoading', true);

      return schoolsApi.updateSchoolStatuses(schoolCodes, date, nonOperational)
        .then(() => {
          commit('setIsLoading', false);
        })
        .catch((err) => {
          commit('setIsLoading', false);
          if (err.response && err.response.data && err.response.data.message) {
            throw err.response.data.message;
          }

          throw err;
        });
    }
  }
};

export default schoolsModule;